/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateTenantThemeDto } from '../models/CreateTenantThemeDto';
import type { PublicSolicitorListResponseDto } from '../models/PublicSolicitorListResponseDto';
import type { SolicitorSearchResponseDto } from '../models/SolicitorSearchResponseDto';
import type { TenantThemeDto } from '../models/TenantThemeDto';
import type { UpdateTenantThemeDto } from '../models/UpdateTenantThemeDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PublicService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get approved solicitors for public display
     * Returns a list of approved and active solicitors. Requires a valid X-Charity-Tenant-Key header.
     * @param xCharityTenantKey API key for charity authentication
     * @param page Page number (default: 1)
     * @param limit Items per page (default: 10)
     * @param sortActive Field to sort by (default: organization_name)
     * @param sortDirection Sort direction (default: asc)
     * @param filter Search filter text
     * @returns PublicSolicitorListResponseDto List of solicitors retrieved successfully.
     * @throws ApiError
     */
    public publicControllerGetPublicSolicitors(
        xCharityTenantKey: string,
        page?: number,
        limit?: number,
        sortActive?: string,
        sortDirection?: 'asc' | 'desc',
        filter?: string,
    ): Observable<PublicSolicitorListResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/public/charities/solicitors',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortActive': sortActive,
                'sortDirection': sortDirection,
                'filter': filter,
            },
            errors: {
                401: `Invalid or missing tenant key.`,
            },
        });
    }
    /**
     * Get tenant theme configuration
     * Returns the theme configuration for the charity identified by the tenant key. Public endpoint used by iframes.
     * @param xCharityTenantKey API key for charity authentication
     * @returns TenantThemeDto Theme configuration retrieved successfully.
     * @throws ApiError
     */
    public tenantThemeControllerGetTheme(
        xCharityTenantKey: string,
    ): Observable<TenantThemeDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/public/tenant-theme',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            errors: {
                401: `Invalid or missing tenant key.`,
                404: `Theme not found for the charity.`,
            },
        });
    }
    /**
     * Create tenant theme configuration
     * Creates a new theme configuration for the charity identified by the tenant key. Requires Super Admin authentication.
     * @param xCharityTenantKey API key for charity authentication
     * @param requestBody Theme configuration data
     * @returns TenantThemeDto Theme configuration created successfully.
     * @throws ApiError
     */
    public tenantThemeControllerCreateTheme(
        xCharityTenantKey: string,
        requestBody: CreateTenantThemeDto,
    ): Observable<TenantThemeDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/public/tenant-theme',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data.`,
                401: `Invalid or missing tenant key or JWT token.`,
                403: `Access denied. Super Admin role required.`,
                404: `Charity not found.`,
                409: `Theme already exists for this charity.`,
            },
        });
    }
    /**
     * Update tenant theme configuration
     * Updates the theme configuration for the charity identified by the tenant key. Requires Super Admin authentication.
     * @param xCharityTenantKey API key for charity authentication
     * @param requestBody Theme configuration data to update
     * @returns TenantThemeDto Theme configuration updated successfully.
     * @throws ApiError
     */
    public tenantThemeControllerUpdateTheme(
        xCharityTenantKey: string,
        requestBody: UpdateTenantThemeDto,
    ): Observable<TenantThemeDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/public/tenant-theme',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data.`,
                401: `Invalid or missing tenant key or JWT token.`,
                403: `Access denied. Super Admin role required.`,
                404: `Theme or charity not found.`,
            },
        });
    }
    /**
     * Delete tenant theme configuration
     * Deletes the theme configuration for the charity identified by the tenant key. Requires Super Admin authentication.
     * @param xCharityTenantKey API key for charity authentication
     * @returns void
     * @throws ApiError
     */
    public tenantThemeControllerDeleteTheme(
        xCharityTenantKey: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/public/tenant-theme',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            errors: {
                401: `Invalid or missing tenant key or JWT token.`,
                403: `Access denied. Super Admin role required.`,
                404: `Theme or charity not found.`,
            },
        });
    }
    /**
     * Search solicitors by postcode or location
     * Returns solicitors within the specified radius (default 50km) of the given Australian postcode or location name. Requires a valid X-Charity-Tenant-Key header.
     * @param xCharityTenantKey API key for charity authentication
     * @param query Australian postcode (4 digits) or location name
     * @param radius Search radius in kilometers (default: 50, max: 50, min: 1)
     * @returns SolicitorSearchResponseDto List of solicitors within the search radius.
     * @throws ApiError
     */
    public solicitorSearchControllerSearchSolicitors(
        xCharityTenantKey: string,
        query: string,
        radius?: number,
    ): Observable<SolicitorSearchResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/public/solicitors/search',
            headers: {
                'X-Charity-Tenant-Key': xCharityTenantKey,
            },
            query: {
                'query': query,
                'radius': radius,
            },
            errors: {
                400: `Invalid query or radius parameter.`,
                401: `Invalid or missing tenant key.`,
                429: `Too many requests. Rate limit exceeded.`,
            },
        });
    }
}
